import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate ,useLocation} from "react-router-dom";
import { useForm } from "react-hook-form";
import Documents from "./Documents";
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    Typography,
    TextField,

} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle'; // Represents a user profile
import BadgeIcon from '@mui/icons-material/Badge';               // Represents an ID badge
import PersonSearchIcon from '@mui/icons-material/PersonSearch';    // Represents an ID badge
import PaymentIcon from '@mui/icons-material/Payment';           // Represents payment
import CreditCardIcon from '@mui/icons-material/CreditCard';     // Represents credit card payments
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';   // Represents money/payment
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'; // Represents money handling
import AttachFileIcon from '@mui/icons-material/AttachFile';     // Represents a file attachment
import AttachmentIcon from '@mui/icons-material/Attachment';     // Another variant of file attachment
import DescriptionIcon from '@mui/icons-material/Description';
import * as actions from '../actions/micustomeractions'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import * as appUtilityFunctions from '../../../infrastructure/apputilityfunctions'
import FullMemberDetails from './FullMemberDetails';
import * as appConstants from '../../../overrides/appconstants'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import sharedGlobals from "../../../sharedglobals";
import * as appactions  from '../../../actions/appactions'
export default function Payment() {
    const state = useSelector(state => state.miCustomerSharedReducer);
    let activeStep = state.activeStep;
    let modalState = state.modalState;
    let masters = state.masters;
    const dispatch = useDispatch();
    const navigate = useNavigate();
     const location = useLocation();
    let documents = state.quoteDocuments;

    let premiumSummary = state.premiumSummary;
    let productId = state.productId;




    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();
    let payment = state.payment;
    const { register: registerPremiumSummary,
        reset: resetPremiumSummary, handleSubmit: handleSubmitPremiumSummary, setValue: setPremiumSummaryValues, formState: { errors: errorsPremiumSummary } } = useForm();

    let productSelection = state.productSelection;
    let basicInfoNewEnq = state.basicInfoNewEnq;
    let memberBasePrem = state.membersBasePremiumRates;
    let planType = state.planType;

    console.log('xxxxx', payment.plan, productSelection?.planType, planType, masters.portalPlanTypeMastersFilterd);
    console.log('wewew', basicInfoNewEnq?.planType);
    useEffect(() => {


        let valuesToMap = [
            { "paymentMode": payment.paymentMode },
            { "termsCond": payment.termsCond },
            { "plan": payment.plan ?? productSelection?.planType ?? basicInfoNewEnq?.planType ?? planType },
            { "netToPay": payment.netToPay },
            { "premuim": payment.netToPay },

        ];
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setValue(key, i[key])));
    }, [payment, basicInfoNewEnq, masters.portalPlanTypeMastersFilterd]);

    useEffect(() => {
               const queryParams = new URLSearchParams(location.search);
               const encryptedEnquiryRefId1 = queryParams.get("encryptedEnquiryRefId1");
                       const encryptedEnquiryRefId2 = queryParams.get("encryptedEnquiryRefId2");
                       if (encryptedEnquiryRefId1 && encryptedEnquiryRefId2) {
                          
                           dispatch(actions.getQuoteInformation(/* id */{ encryptedEnquiryRefId1, encryptedEnquiryRefId2 }));
                       }else{
        dispatch(actions.getQuoteInformation({ encryptedEnquiryRefId1: basicInfoNewEnq?.encryptedEnquiryRefId1, encryptedEnquiryRefId2:basicInfoNewEnq?.encryptedEnquiryRefId2 }))
}}, []);



    useEffect(() => {
        let valuesToMap = [
            { "plan": premiumSummary.plan },
            { "premium": appUtilityFunctions.formatAmount(premiumSummary.premium) },
            { "documentFee": appUtilityFunctions.formatAmount(premiumSummary.documentFee) },
            { "basmaFee": appUtilityFunctions.formatAmount(premiumSummary.basmaFee) },
            { "hcvFee": appUtilityFunctions.formatAmount(premiumSummary.hcvFee) },
            { "haadPenalty": appUtilityFunctions.formatAmount(premiumSummary.haadPenalty) },
            { "commission": appUtilityFunctions.formatAmount(premiumSummary.commission) },
            { "vat": appUtilityFunctions.formatAmount(premiumSummary.vat) },
            { "netToPay": appUtilityFunctions.formatAmount(premiumSummary.netToPay) },
            { "planName": premiumSummary.planName },
            { "icpFee": appUtilityFunctions.formatAmount(premiumSummary.icpFee) },
            { "planType": premiumSummary.planType },
            { "basePremium": appUtilityFunctions.formatAmount(premiumSummary.basePremium) },
        ];
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setPremiumSummaryValues(key, i[key])));
    }, [premiumSummary]);
    const onChangePremiumSummary = () => {


    }

    useEffect(() => {
        async function CheckPermissions() {

            await dispatch(actions.getPremiumSummary());

        }
        CheckPermissions();


    }, []);

    const downloadPrivacyNotice = () => {
        window.open("https://static1.alsagrins.ae/general/PrivacyNotice.pdf");
    }
    const regeneratePeanlty = async () => {
        await dispatch(actions.processCOCBatchOnApprovals());
        await dispatch(actions.getPremiumSummary());
    }; 
    const onShareLinkButtonClick = async () => {
        var a= encodeURIComponent(basicInfoNewEnq.encryptedEnquiryRefId1);
        var b= encodeURIComponent(basicInfoNewEnq.encryptedEnquiryRefId2);
     var q=   ("customerportal?encryptedEnquiryRefId1="+a+"&encryptedEnquiryRefId2="+b+"&mode=payment");
            navigator.clipboard.writeText(sharedGlobals.appUrls.miCustomerUrl+ q );
            dispatch(appactions.showTopMessage('Link Copied', { autoClose: "y", messageType: "success" }))
    };
    let Plan = <input className='form-control  mb-2'
        name="planName"
        id="planName"
        disabled={true}
        type="text"
        placeholder="Plan"
        {...register("plan",)}
    />
    // let PlanPrem = <input className='form-control'
    //     name="premuim"
    //     id="premuim"
    //     disabled={true}
    //     type="text"
    //     placeholder="premuim"
    //     {...register("premuim")}
    // />

    let NetToPay = <input className='form-control'
        name="netToPay"
        id="netToPay"
        disabled={true}
        type="text"
        placeholder="Net To Pay"
        // {...register("netToPay")}
        {...registerPremiumSummary("netToPay", { required: false, onChange: (e) => onChangePremiumSummary(e) })}
    />
    let PlanPrem = <input className='form-control'
        name="basePremium"
        id="basePremium"
        disabled={true}
        type="text"
        placeholder="Plan Premium"
        // {...register("netToPay")}
        {...registerPremiumSummary("basePremium", { required: false, onChange: (e) => onChangePremiumSummary(e) })}
    />
    let DocumentFee = <input className='form-control'
        name="documentFee"
        id="documentFee"
        disabled={true}
        type="text"
        placeholder="Document Fee"
        {...registerPremiumSummary("documentFee", { required: false, onChange: (e) => onChangePremiumSummary(e) })}
    />
    let VatAmount = <input className='form-control'
        name="vat"
        id="vat"
        disabled={true}
        type="text"
        placeholder="Vat Amount"
        {...registerPremiumSummary("vat", { required: false, onChange: (e) => onChangePremiumSummary(e) })}
    />
    let HaadPenalty = <input className='form-control'
        name="haadPenalty"
        id="haadPenalty"
        disabled={true}
        type="text"
        placeholder="Haad Peanlty"
        {...registerPremiumSummary("haadPenalty", { required: false, onChange: (e) => onChangePremiumSummary(e) })}
    />
    //     let DocumentFee = <input className={errorsPremiumSummary.documentFee ? 'form-control  is-invalid' : 'form-control'}
    //     name="documentFee"
    //     id="documentFee"
    //     disabled={true}
    //     type="text"
    //     placeholder="Document Fee"
    //     {...registerPremiumSummary("documentFee", { required: true, onChange: (e) => onChangePremiumSummary(e) })}
    // />
    let AgreeTerms = <input type="checkbox" name="agreeTerms"
        id="agreeTerms" className="form-check-input"
        {...register("termsCond")}
        checked={payment?.termsCond}
        disabled={basicInfoNewEnq?.isPaymentProcessed == true}
        onChange={value => handlePaymentCheckboxChange(value)}
    />
    let PaymentMode = <select className="form-select" data-toggle="select2" id="paymentMode" name="paymentMode"
        value={payment.paymentMode}
        disabled
        onChange={value => handlePaymentTransactionsParams(value)}>
        <option value="">--Payment Mode--</option>
        {masters?.paymentModeMasters?.map((paymentMode) => (
            <option value={paymentMode.domainValue} key={paymentMode.domainValue}>
                {paymentMode.domainValueName}
            </option>
        ))}
    </select>
    let PlanType =
        <select
            value={payment?.plan}
            className='form-select'
            data-toggle="select2"
            id="plan"
            name="plan"
            disabled
            {...register("plan",
            )}


        >
            <option value="">-- Select Plan Type --</option>
            {masters.portalPlanTypeMastersFilterd.map((portalPlanType, index) => (
                <option value={portalPlanType.domainValue} key={portalPlanType.domainValue}>
                    {portalPlanType.domainValueName}
                </option>
            ))}
        </select>
    const handlePaymentTransactionsParams = async (e) => {
        let { name, value } = e.target;
        await dispatch(actions.updatePaymentTransactionsParams({ name, value }));

    }
    // const onDisplayCurrentBasePremium = async (planId, productId) => {

    //     await dispatch(actions.getMembersBasePremiumByPlan(planId, productId));

    // }

    const onDisplayCurrentBasePremium = async () => {
        let name = "showPremiumBreakDown";
        let value = true
        await dispatch(actions.updateModalState({ name, value }));
    }
    const handlePaymentCheckboxChange = async (e) => {
        let { name, value, checked } = e.target;

        // await dispatch(updatePaymentTransactionsParams({ name: name, value: value }));

        if (name == "termsCond") {
            dispatch(actions.showTermsAndComdPopap({ name, value: checked, message: getTermsandConditions() }));

        }
        else {
            // let name = "agreeTerms";
            // let value = true;
            // await dispatch(actions.updatePaymentTransactionsParams({ name, value }));

        }
    }


    function getTermsandConditions() {
        return (
            <div>
                <ul >
                    <li>I have read the term and conditions of the policy and agree to them completely.</li>
                    <li style={{ textAlign: 'justify' }}>I/We hereby declare with respect to both, myself and my dependents that to the best of my knowledge and belief, the statement on application are full, true and correct and have declared all material facts related to this application.
                    </li>
                    <li>I/We understand that non-disclosure or misrepresentation of any material fact may invalidate the quoted terms. I/We agree that all the documents issued in connection with the policy shall be read together. If my application gets accepted. I/We agree to be bound by the terms and conditions of the policy.
                    </li>
                    <li>I/We hereby authorize any doctor, Hospital, Clinic or Medical Provider ,any Insurance Company or any other Company ,institution or any other person who has any record or information about me and/or any of my family members to provide Al Sagr National Insurance Company, with the complete information, including copies of their records with reference to any sickness or accident, any treatment, examination, advice or hospitalization or any other medical information required by Al Sagr National Insurance Company. The Coverage of Health Services provided by Al Sagr National Insurance Company is described in the policy wording.
                    </li>
                    <li>By signing this for, I/We acknowledge that I/We read, understood, and agree to the terms and conditions as stated in the policy wording.
                    </li>
                    <li>I/We agree that after acceptance of the quoted premiums in the quotation, I/We shall be liable to pay all the premiums to Al Sagr National Insurance Company as per the specified and selected plan of our choice.
                    </li>
                    <li>Al Sagr National Insurance Company reserves the right to reject any authorization/claims request for conditions (pre-existing, chronic) not declared by the applicant at the inception of the policy.
                    </li>
                    <li>I understand that checking the below box constitutes a legal signature confirming that I agree to the above terms and conditions of Al Sagr Insurance Company. Any non-disclosure / misrepresentation or concealment of material facts will make this policy void with immediate effect without any entitlement for refund. In the event, this medical application form has been completed by someone else; I take full responsibility of the information provided, and agree that a true declaration has been given.
                    </li>
                    <li>By continuing, you agree to our <a href="#" onClick={() => downloadPrivacyNotice()}>Privacy Notice</a>. Please review it before proceeding. </li>



                </ul>

            </div>

        )
    }
    const onProceedToPay = async () => {
        if (basicInfoNewEnq?.isRefertoUW) {
            let dialogeData = {
                message: 'Your enquiry has been referred to our underwriting team & the final premium will be shared with you shortly!',
                showConfirmPopup: true,
                isConfirm: false,
                isInfo: true,
            }
            await dispatch(actions.toggleConfirmPopup(dialogeData));
            return;
        }
        await dispatch(actions.onProceedToPay());
    }
    const onGenerateKYCReport = async () => {
        // let reportContext = {
        //     ReportId: 2,
        //     ParamValues: [
        //         {
        //             ParamId: 9,
        //             ParentParamId: null,
        //             Value: "54813",
        //             Name: "QUOTATION_ID",
        //         },
        //     ],
        // };
        let reportContext = {
            ReportId: appConstants.KYC_REPORT_ID,
            ParamValues: [
                {
                    ParamId: appConstants.KYC_REPORT_PARAM_ID,
                    ParentParamId: null,
                    Value: basicInfoNewEnq?.quoteId ? basicInfoNewEnq?.quoteId.toString() : basicInfoNewEnq?.enquiryId?.toString(),
                    Name: "QUOTATION_ID",
                },
            ],
        };
        dispatch(actions.getKYCReport(reportContext))
    }
    const onDocumentButton = async () => {
        // await dispatch(actions.getQuoteDocumentList());
        if (documents.documentList.length === 0) {
            await dispatch(actions.getQuoteDocumentMasters());
            await dispatch(actions.getQuoteDocuments());
        }
        await dispatch(actions.showQuoteDocumentTab());
    }
    const handleBack = async () => {
        //     alert(basicInfoNewEnq?.visaEmirate && basicInfoNewEnq?.visaEmirate != appConstants.VISA_EMIRATE_ABU_DHABI && basicInfoNewEnq?.visaEmirate != appConstants.VISA_EMIRATE_DUBAI && basicInfoNewEnq?.visaEmirate != appConstants.VISA_EMIRATE_AL_AIN)
        if (productId == appConstants.NE_BASIC_ESS_PRODUCT_ID || productId == appConstants.NE_BASIC_PRODUCT_ID) {
            await dispatch(actions.handleNextStep(2))
        }
        else {
            await dispatch(actions.handleNextStep(3))
        }



    }
    const handleNext = async () => {

        navigate('/FullMemberDetails?encryptedEnquiryRefId1=' + basicInfoNewEnq?.encryptedEnquiryRefId1 + "&encryptedEnquiryRefId2=" + basicInfoNewEnq?.encryptedEnquiryRefId2)




    }

    function renderMemberBasePremuim() {

        return (
            <>


                <div className="table-responsive">
                    <table className="table table-hover table-custom">
                        <thead className="table-header">
                            <tr>
                                {/* <th>
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                id="CheckAll"
                                                className="form-check-input"
                                                onChange={value => handleAllMemberCheckboxChange(value)}
                                            />
                                        </div>
                                    </th> */}
                                <th>No.</th>
                                <th> Member Name	</th>
                                <th> Gender</th>
                                <th> Marital Status</th>
                                <th> Date Of Birth</th>
                                <th> Relation</th>
                                <th> Premium (AED)</th>

                            </tr>
                        </thead>
                        {memberBasePrem.length != 0 ? (
                            <tbody>
                                {memberBasePrem.map((result, index) => (
                                    <tr key={result.srlNo} className="table-row">
                                        <td> {(Number(index) + Number(1))} </td>
                                        <td> {result.memberFullName}</td>
                                        <td> {result.gender} </td>
                                        <td> {result.maritalStatus}  </td>
                                        <td>   {appUtilityFunctions.formatDate(result.dateOfBirth)}  </td>
                                        <td> {result.relation}  </td>
                                        <td> {appUtilityFunctions.formatAmount(result.basePremium)}     </td>



                                    </tr>
                                ))}
                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan="8" className="text-center">
                                        <div className="alert alert-warning">No Plans Found...</div>
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>

            </>
        )
    }
    function renderPayment() {

        return (
            <>
                <div className="row">
                    <div className="col">
                        <div className="row pt-3 d-flex mb-3">
                            <div className=" col-md-6 col-sm-12 d-flex">
                                <div className="col-4 text-start">
                                    <label htmlFor="visaType"
                                        className="form-label w-100">  Plan Type  </label>
                                </div>
                                <div className="col-8">
                                    {PlanType}

                                </div>
                            </div>

                        </div>
                        <div className="row">
                            <div className=" col-md-6 col-sm-12 d-flex" style={{ alignItems: 'center' }}>
                                <div className="col-4 text-start">
                                    <label htmlFor="visaType"
                                        className="form-label w-100"> Plan Premium  (AED)   </label></div>


                                <div className="col-8 d-flex align-items-baseline">
                                    {PlanPrem}
                                    {/*   */}


                                </div>
                                {/* <i class="dripicons-preview px-2" style={{ color: 'green', cursor: 'pointer' }} title="View Base Premium Breakdown"
                                 onClick={() => onDisplayCurrentBasePremium()}
                                ></i> */}

                            </div>

                        </div>
                        <div className="row mt-2">
                            <div className=" col-md-6 col-sm-12 d-flex" style={{ alignItems: 'center' }}>
                                <div className="col-4 text-start">
                                    <label htmlFor="visaType"
                                        className="form-label w-100">  Document Fee </label></div>
                                <div className="col-8">
                                    {DocumentFee}

                                </div>

                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className=" col-md-6 col-sm-12 d-flex" style={{ alignItems: 'center' }}>
                                <div className="col-4 text-start">
                                    <label htmlFor="visaType"
                                        className="form-label w-100">  VAT  </label></div>
                                <div className="col-8">
                                    {VatAmount}

                                </div>

                            </div>
                        </div>
                        {(basicInfoNewEnq.visaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || basicInfoNewEnq.visaEmirate == appConstants.VISA_EMIRATE_AL_AIN) && <div className="row mt-2">
                            <div className=" col-md-6 col-sm-12 d-flex" style={{ alignItems: 'center' }}>
                                <div className="col-4 text-start">
                                    <label htmlFor="visaType"
                                        className="form-label w-100"> Haad Penalty </label></div>
                                <div className="col-8">
                                    <div className="input-group">
                                        {HaadPenalty}
                                        <button type="button" class="btn btn-warning" title="Re-Generate Penalty" onClick={() => regeneratePeanlty()}><i className="uil uil-refresh"></i></button>

                                    </div>

                                </div>
                                <div className="col-md-8 mx-2">
                                    <span className='text-danger'>* After penalty is paid, please click here to re-generate</span>
                                </div>


                            </div>
                        </div>}
                        <div className="row mt-2">
                            <div className=" col-md-6 col-sm-12 d-flex" style={{ alignItems: 'center' }}>
                                <div className="col-4 text-start">
                                    <label htmlFor="visaType"
                                        className="form-label w-100">  Net To Pay (AED)  </label></div>
                                <div className="col-8">
                                    {NetToPay}

                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="row" style={{ alignItems: 'end' }}>
                            <div className="col-md-6">
                                <div className='mb-3' >
                                    {AgreeTerms}
                                    <label htmlFor="agreeTerms" className="form-label"> &nbsp;  I agree to all terms and conditions.</label>

                                </div>
                                <div >
                                    
                                    {PaymentMode}   
                                     {/* <Button
                                            variant="contained"
                                            color="warning"
                                            type="submit"

                                            startIcon={
                                                <ContentCopyIcon />
                                            }
                                            onClick={() => onShareLinkButtonClick()}
                                        >
                                            Copy Link
                                        </Button> */}
                                </div>  
                              

                            </div>


                        </div>
                        <div className="row">
                            <div  >
                                <div className="row pt-2">
                                    <div className='col-md-2 mt-2'>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"

                                            startIcon={
                                                <PersonSearchIcon />
                                            }
                                            onClick={() => onGenerateKYCReport()}
                                        >
                                            KYC
                                        </Button>
                                    </div>

                                    <div className='mt-2 col-md-3'>

                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"

                                            startIcon={
                                                <CreditCardIcon />
                                            }
                                            onClick={() => onProceedToPay()}
                                        >

                                            Proceed To Pay
                                        </Button>
                                    </div>
                                    <div className='mt-2 col-md-3'>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"

                                            startIcon={
                                                <AttachFileIcon />
                                            }
                                            onClick={() => onDocumentButton()}
                                        >
                                            Attach Document
                                        </Button>
                                    </div>
                                    
                                    <div className='mt-2 col-md-3'>
                                      <Button
                                            variant="contained"
                                            color="warning"
                                            type="submit"

                                            startIcon={
                                                <ContentCopyIcon />
                                            }
                                            onClick={() => onShareLinkButtonClick()}
                                        >
                                            Copy Link
                                        </Button>
                                         </div>
                                    <div >
                                </div>  
                               
                                </div>

                            </div>

                        </div>

                    </div>

                    {basicInfoNewEnq?.isRefertoUW &&
                        <h4 className='text-danger pt-2'>* The given premium is indicative. The quote will be referred to the underwriter to offer final premium</h4>}
                    {modalState?.memberBasePremModal && renderMemberBasePremuim()}

                    <div className="row">
                        <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                className='mx-2'
                                variant="outlined"
                                type='button'
                                color="secondary"
                                onClick={handleBack}
                                startIcon={<ArrowBackIcon />}

                            >
                                Back
                            </Button>

                            {(basicInfoNewEnq?.isPolicyIssued && basicInfoNewEnq?.isPaymentProcessed) &&
                                <Button
                                    variant="contained"
                                    type='button'
                                    color="primary"
                                    onClick={handleNext}
                                    endIcon={<ArrowForwardIcon />}

                                >
                                    Full Member Details
                                </Button>}
                        </Box>

                    </div>
                    {(documents?.showMemberTab || documents?.showDocumentsTab) && <Documents />}
                </div >
            </>
        )
    }
    function renderPremiumSummary() {
        let Plan = <input className={errorsPremiumSummary.plan ? 'form-control  is-invalid' : 'form-control'}
            name="planName"
            id="planName"
            disabled={true}
            type="text"
            placeholder="planName"
            {...registerPremiumSummary("planName", { required: true, onChange: (e) => onChangePremiumSummary(e) })}
        />
        // let Plan = <select className={errorsPremiumSummary.plan ? 'form-select  is-invalid' : 'form-select'}
        //     name="plan"
        //     data-toggle="select2"
        //     id="plan"
        //     disabled={true}
        //     {...registerPremiumSummary("plan", { required: true, onChange: (e) => onChangePremiumSummary(e) })}
        // >
        //     <option value=''>---- Select ---- -</option>
        // </select>
        let PaymentMode = <select className={errorsPremiumSummary.paymentMode ? 'form-select  is-invalid' : 'form-select'}
            name="paymentMode"
            data-toggle="select2"
            id="paymentMode"
            disabled={false}
            {...registerPremiumSummary("paymentMode", { required: false, onChange: (e) => onChangePremiumSummary(e) })}
        >
            <option value=''>---- Select ---- -</option>
        </select>
        let Premium = <input className={errorsPremiumSummary.premium ? 'form-control  is-invalid' : 'form-control'}
            name="premium"
            id="premium"
            disabled={true}
            type="text"
            placeholder="Premium"
            {...registerPremiumSummary("premium", { required: true, onChange: (e) => onChangePremiumSummary(e) })}
        />
        let DocumentFee = <input className={errorsPremiumSummary.documentFee ? 'form-control  is-invalid' : 'form-control'}
            name="documentFee"
            id="documentFee"
            disabled={true}
            type="text"
            placeholder="Document Fee"
            {...registerPremiumSummary("documentFee", { required: true, onChange: (e) => onChangePremiumSummary(e) })}
        />
        let BasmaFee = <input className={errorsPremiumSummary.basmaFee ? 'form-control  is-invalid' : 'form-control'}
            name="basmaFee"
            id="basmaFee"
            disabled={true}
            type="text"
            placeholder="Basma Fee"
            {...registerPremiumSummary("basmaFee", { required: true, onChange: (e) => onChangePremiumSummary(e) })}
        />
        let HcvFee = <input className={errorsPremiumSummary.hcvFee ? 'form-control  is-invalid' : 'form-control'}
            name="hcvFee"
            id="hcvFee"
            disabled={true}
            type="text"
            placeholder="Hcv Fee"
            {...registerPremiumSummary("hcvFee", { required: true, onChange: (e) => onChangePremiumSummary(e) })}
        />
        let IcpFee = <input className={errorsPremiumSummary.icpFee ? 'form-control  is-invalid' : 'form-control'}
            name="icpFee"
            id="icpFee"
            disabled={true}
            type="text"
            placeholder="Hcv Fee"
            {...registerPremiumSummary("icpFee", { required: true, onChange: (e) => onChangePremiumSummary(e) })}
        />
        let HaadPenalty = <input className={errorsPremiumSummary.haadPenalty ? 'form-control  is-invalid' : 'form-control'}
            name="haadPenalty"
            id="haadPenalty"
            disabled={true}
            type="text"
            placeholder="Haad Penalty"
            {...registerPremiumSummary("haadPenalty", { required: true, onChange: (e) => onChangePremiumSummary(e) })}
        />
        // let Commission = <input className={errorsPremiumSummary.commission ? 'form-control  is-invalid' : 'form-control'}
        //     name="commission"
        //     id="commission"
        //     disabled={true}
        //     type="text"
        //     placeholder="Commission"
        //     {...registerPremiumSummary("commission", { required: true, onChange: (e) => onChangePremiumSummary(e) })}
        // />
        let Vat = <input className={errorsPremiumSummary.vat ? 'form-control  is-invalid' : 'form-control'}
            name="vat"
            id="vat"
            disabled={true}
            type="text"
            placeholder="Vat"
            {...registerPremiumSummary("vat", { required: true, onChange: (e) => onChangePremiumSummary(e) })}
        />
        let NetToPay = <input className={errorsPremiumSummary.netToPay ? 'form-control  is-invalid' : 'form-control'}
            name="netToPay"
            id="netToPay"
            disabled={true}
            type="text"
            placeholder="Net To Pay"
            {...registerPremiumSummary("netToPay", { required: true, onChange: (e) => onChangePremiumSummary(e) })}
        />
        let Amount = <input className={errorsPremiumSummary.amount ? 'form-control  is-invalid' : 'form-control'}
            name="amount"
            id="amount"
            disabled={false}
            type="text"
            placeholder="Amount"
            {...registerPremiumSummary("amount", { required: false, onChange: (e) => onChangePremiumSummary(e) })}
        />

        let CommissionUpsellingDownSelling = <input className={errorsPremiumSummary.commissionUpsellingDownSelling ? 'form-control  is-invalid' : 'form-control'}
            name="commissionUpsellingDownSelling"
            id="commissionUpsellingDownSelling"
            disabled={false}
            type="number"
            placeholder="Commission (%)"
            {...registerPremiumSummary("commissionUpsellingDownSelling", { required: false, onChange: (e) => onChangePremiumSummary(e) })}
        />
        let AgreeTerms = <input type="checkbox" name="agreeTerms"
            id="agreeTerms" className="form-check-input"
            checked={premiumSummary.agreeTerms}
            onChange={value => handlePaymentCheckboxChange(value)}
        />
        let PromoCodeAvailable = <input type="checkbox" name="promoCodeAvailable"
            id="promoCodeAvailable" className="form-check-input"
            checked={premiumSummary.promoCodeAvailable}
            onChange={value => handlePaymentCheckboxChange(value)}
        />



        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <div className="collapse show" id="CollapsePremiumSummary">
                    <div className="row g-2">
                        <div className="mb-1 col-md-12">
                            <div className="btn-group float-end" id="tooltip-container2">
                            </div>
                        </div>
                    </div>
                    <div className="row pt-3 d-flex mb-3">
                        <div className=" col-md-6 col-sm-12 d-flex">
                            <div className="col-4 text-start">
                                <label htmlFor="visaType"
                                    className="form-label w-100">  Plan Type  </label>
                            </div>
                            <div className="col-8">
                                {PlanType}

                            </div>
                        </div>

                    </div>
                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <div className="row g-2">
                                <div className="mb-3 col-md-12">
                                    <label htmlFor="inputPassword4" className="form-label">Plan</label>
                                    {Plan}
                                </div>
                            </div>

                            <div className="row g-2">
                                <div className="mb-3 col-md-12">
                                    <label htmlFor="inputPassword4" className="form-label">Premium</label>
                                    {Premium}
                                </div>
                            </div>
                            <div className="row g-2">
                                <div className="mb-3 col-md-12">
                                    <label htmlFor="inputPassword4" className="form-label">Document Fee</label>
                                    {DocumentFee}
                                </div>
                            </div>
                            {/* <div className="row g-2">
                                <div className="mb-3 col-md-12">
                                    <label htmlFor="inputPassword4" className="form-label">Basma Fee</label>
                                    {BasmaFee}
                                </div>
                            </div>
                            <div className="row g-2">
                                <div className="mb-3 col-md-12">
                                    <label htmlFor="inputPassword4" className="form-label">Hcv Fee</label>
                                    {HcvFee}
                                </div>
                            </div>
                            <div className="row g-2">
                                <div className="mb-3 col-md-12">
                                    <label htmlFor="inputPassword4" className="form-label">ICP Fee</label>
                                    {IcpFee}
                                </div>
                            </div>
                            <div className="row g-2">
                                <div className="mb-3 col-md-12">
                                    <label htmlFor="inputPassword4" className="form-label">Haad Penalty</label>
                                    {HaadPenalty}
                                </div>
                            </div> */}
                            {/* <div className="row g-2">
                                <div className="mb-3 col-md-12">
                                    <label htmlFor="inputPassword4" className="form-label">Commission</label>
                                    {Commission}
                                </div>
                            </div> */}
                            <div className="row g-2">
                                <div className="mb-3 col-md-12">
                                    <label htmlFor="inputPassword4" className="form-label">Vat</label>
                                    {Vat}
                                </div>
                            </div>
                            <div className="row g-2">
                                <div className="mb-3 col-md-12">
                                    <label htmlFor="inputPassword4" className="form-label">Net To Pay</label>
                                    {NetToPay}
                                </div>
                            </div>

                        </div>
                        <div className="mb-3 col-md-5"></div>


                    </div>

                </div>





            </>
        )
    }
    function renderMemberPremium() {
        let memberDetails = premiumSummary.memberPremium;
        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                    <li className="nav-item">
                        <a href="#scroll-horizontal-preview" data-bs-toggle="tab" aria-expanded="false" className="nav-link">
                        </a>
                    </li>
                </ul>

                <div className="collapse show" id="CollapseMemberPremiumSection" >

                    <div className="row g-2 ">
                        <div className="col-md-4 "></div>
                        <div className="col-md-4 "> </div>
                        {/* <div className="col-md-4 ">
                            <div className="input-group ">
                                <span class="input-group-text bg-warning"> <i style={{ transform: "scaleX(-1)" }} className="dripicons-search" ></i></span>
                                <input className="form-control " placeholder="Search Member By Name" id="searchMember" name="searchMember"
                                    onChange={(value) => searchMemberTable(value)}
                                ></input>

                            </div>
                        </div> */}

                    </div>
                    {//memberDetails.length > 0  && 

                        <div className="table-responsive">
                            <table id="scroll-horizontal-datatable" className="table table-striped w-100 nowrap">
                                <thead>
                                    <tr>
                                        {/* <th>S No.</th> */}
                                        <th>S. No.</th>
                                        <th>Member Name</th>
                                        <th>Age</th>
                                        <th>BMI</th>
                                        <th>Premium (AED) </th>
                                        <th>Loading (AED) </th>


                                        {(basicInfoNewEnq.visaEmirate == appConstants.VISA_EMIRATE_DUBAI) && <th>BASMA Fee (AED)</th>}
                                        {(basicInfoNewEnq.visaEmirate == appConstants.VISA_EMIRATE_DUBAI) && <th>HCV Fee (AED)</th>}
                                        {(basicInfoNewEnq.visaEmirate != appConstants.VISA_EMIRATE_DUBAI) && <th>ICP Fee (AED)</th>}
                                        <th>VAT (AED) </th>
                                        <th>Total  (AED) (without document fee)</th>
                                        {(basicInfoNewEnq.visaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || basicInfoNewEnq.visaEmirate == appConstants.VISA_EMIRATE_AL_AIN) && <th>COC Ref Number</th>}
                                        {(basicInfoNewEnq.visaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || basicInfoNewEnq.visaEmirate == appConstants.VISA_EMIRATE_AL_AIN) && <th>HAAD Penalty (AED)</th>}


                                    </tr>
                                </thead>
                                <tbody>
                                    {memberDetails.map((member, index) => (
                                        <tr key={index} >
                                            <td>{index + 1}</td>
                                            <td>{member.fullName}</td>
                                            <td>{member.age}</td>
                                            <td>{member.bmi}</td>
                                            <td>{appUtilityFunctions.formatAmount(member.basePremium)}</td>
                                            <td>{appUtilityFunctions.formatAmount(member.netLoadingAmount)}</td>

                                            {(basicInfoNewEnq.visaEmirate == appConstants.VISA_EMIRATE_DUBAI) && <td>{member.basmaFee}</td>}
                                            {(basicInfoNewEnq.visaEmirate == appConstants.VISA_EMIRATE_DUBAI) && <td>{member.hcvFee}</td>}

                                            {(basicInfoNewEnq.visaEmirate != appConstants.VISA_EMIRATE_DUBAI) && <td>{member.icpFee}</td>}
                                            <td>{appUtilityFunctions.formatAmount(member.vatAmount)}</td>
                                            <td>{appUtilityFunctions.formatAmount(member.total)}</td>
                                            {(basicInfoNewEnq.visaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || basicInfoNewEnq.visaEmirate == appConstants.VISA_EMIRATE_AL_AIN) && <td>{member.cocRefNo}</td>}
                                            {(basicInfoNewEnq.visaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || basicInfoNewEnq.visaEmirate == appConstants.VISA_EMIRATE_AL_AIN) && <td>{member.haadPenalty}</td>}




                                        </tr>

                                    ))}

                                </tbody>
                            </table>


                        </div>

                    }</div>
            </>
        )
    }
    function getHaadTermsandConditions() {
        return (
            <div>
                <h5>General Guidelines for HAAD Penalty:</h5>
                <ul >
                    <li style={{ textAlign: 'justify' }}>If the member's Visa Type is "New Entry," the penalty to be paid manually, and the amount will be included in the total payment due. </li>
                    <li style={{ textAlign: 'justify' }}>If the member's Visa Type is "Resident" and a penalty is applied, the penalty should be paid through TAMM <a href="https://www.tamm.abudhabi/login?redirectUrl=https://www.tamm.abudhabi/en/mylocker" target="_blank">Click Here</a>.</li>
                    <li style={{ textAlign: 'justify' }}>After successfully completing the payment on TAMM, please refresh the screen.</li>
                    <li style={{ textAlign: 'justify' }}>For residents, the payment link will not be generated until the penalty has been paid online. </li>
                    <li style={{ textAlign: 'justify' }}>If there is a waiver of the penalty granted by regulators, the underwriters will waive the penalty upon verification of the waiver evidence.</li>


                </ul>

            </div>

        )
    }
    return (<>
        <ul className="nav nav-tabs nav-bordered mb-1">
        </ul>
        <div className="row g-2">
            <div className="mb-1 col-md-12">
            </div>
            {/* {renderPremiumSummary()} */}

        </div>
        <div className="collapse show" id="CollapseBasicMemberInfoQuote">
            {!payment.paymentDone && <>  {renderPayment()} </>}
            {/*modalState.showPremiumBreakDown &&*/ renderMemberPremium()}
            {(basicInfoNewEnq.visaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || basicInfoNewEnq.visaEmirate == appConstants.VISA_EMIRATE_AL_AIN) && getHaadTermsandConditions()}
            {payment.paymentDone && <>  <FullMemberDetails /> </>}
        </div >
    </>)
}